// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/zcash-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RawTxVoutInnerValue
 */
export interface RawTxVoutInnerValue {
}

/**
 * Check if a given object implements the RawTxVoutInnerValue interface.
 */
export function instanceOfRawTxVoutInnerValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RawTxVoutInnerValueFromJSON(json: any): RawTxVoutInnerValue {
    return RawTxVoutInnerValueFromJSONTyped(json, false);
}

export function RawTxVoutInnerValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawTxVoutInnerValue {
    return json;
}

export function RawTxVoutInnerValueToJSON(value?: RawTxVoutInnerValue | null): any {
    return value;
}

